const getIsDeliveryIntraEurope = (countryFrom: string, countryTo: string): boolean => {
  const BALTIC_LOCALES = ["LT", "LV", "EE"];

  return !BALTIC_LOCALES.includes(countryFrom) || !BALTIC_LOCALES.includes(countryTo);
};

export default getIsDeliveryIntraEurope;
